import styled from "styled-components/macro";

import ExtendedFieldSelector from "./ExtendedFieldSelector/ExtendedFieldSelector";

const SDiv = styled("div")`
  ${({
    theme: {
      colors: { divider, white, fnGrey },
    },
  }) => `
  padding: none;
  border-right: 1px solid ${divider};
  overflow-y: auto;
  overflow-x: clip;
  background-color: ${white};
  border-radius: 0;
  border: 1px solid ${fnGrey};
  `}
`;

const Instructions = styled.span`
  display: inline-block;
  color: ${(p) => p.theme.colors.textSecondary};
  font-size: 12px;
  line-height: 14px;
`;

const InstructionContainer = styled("div")`
  padding: 18px 12px 12px;
`;

const NavInline = () => (
  <SDiv data-cy="ExtendedFieldNav_Container">
    {
      <InstructionContainer>
        <Instructions>
          Add a new extended profile field or click on an existing one to edit
          it. Use the handles to drag them up and down below to rearrange them.
        </Instructions>
      </InstructionContainer>
    }
    <ExtendedFieldSelector />
  </SDiv>
);

export default NavInline;
